import { render } from "./AdminLoginPage.vue?vue&type=template&id=0d5cf7a9"
import script from "./AdminLoginPage.vue?vue&type=script&lang=js"
export * from "./AdminLoginPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__